import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BehanceSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/BehanceSquareOutlined";
import AntdIcon from "../components/AntdIcon";
var BehanceSquareOutlined = function BehanceSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BehanceSquareOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BehanceSquareOutlined.displayName = 'BehanceSquareOutlined';
}
export default /*#__PURE__*/React.forwardRef(BehanceSquareOutlined);